module.exports = __webpack_public_path__ + "img/bgcimg.900622b9.jpg";